/* eslint-disable */
export default {
  _LandscapeMainBackground_4x3: 'LandscapeMainBackground_4x3',
  _save_Screen: 'save_Screen',
  _Container_2: 'Container+2',
  _Container_1: 'Container+1',
  _IntroTreat_1: 'IntroTreat+1',
  _IntroTreat_5: 'IntroTreat+5',
  _IntroTreat_2: 'IntroTreat+2',
  _Flavor_1: 'Flavor+1',
  _Container_3: 'Container+3',
  _Whipping_Bottle: 'Whipping+Bottle',
  _Flavor_2: 'Flavor+2',
  _Container_4: 'Container+4',
  _BG_ITEM_1: 'BG+ITEM+1',
  _BG_Flags: 'BG_Flags',
  _ICON_MenuToppings_1HIGHLIGHT: 'ICON_MenuToppings+1HIGHLIGHT',
  _ICON_MenuToppings_2HIGHLIGHT: 'ICON_MenuToppings+2HIGHLIGHT',
  _Monster_ArmUp: 'Monster_ArmUp',
  _BG_ITEM_6: 'BG+ITEM+6',
  _ICON_MenuContainer_4: 'ICON_MenuContainer+4',
  _bear_coat_bitmap: 'bear/coat_bitmap',
  _bear_head_bitmap: 'bear/head_bitmap',
  _ICON_MenuFlavor_1HIGHLIGHT: 'ICON_MenuFlavor+1HIGHLIGHT',
  _ICON_MenuToppings_3: 'ICON_MenuToppings+3',
  _FlavorSplash_5: 'FlavorSplash+5',
  _ICON_MenuToppings_5HIGHLIGHT: 'ICON_MenuToppings+5HIGHLIGHT',
  _ICON_MenuWhipped_Cream_2HIGHLIGHT: 'ICON_MenuWhipped_Cream+2HIGHLIGHT',
  _Spoon: 'Spoon',
  _Hand_Pointer: 'Hand_Pointer',
  _bear_right_hand_bitmap: 'bear/right_hand_bitmap',
  _Monster_MouthClosed: 'Monster_MouthClosed',
  _ICON_MenuToppings_3HIGHLIGHT: 'ICON_MenuToppings+3HIGHLIGHT',
  _bear_left_hand_bitmap: 'bear/left_hand_bitmap',
  _Monster_MouthOpen: 'Monster_MouthOpen',
  _bear_right_leg_bitmap: 'bear/right_leg_bitmap',
  _Topping_5_1: 'Topping+5+1',
  _Topping_3_1: 'Topping+3+1',
  _CrumbTopping_2_1: 'CrumbTopping+2+1',
  _particle_whipped_cream_3: 'particle_whipped_cream+3',
  _particle_whipped_cream_4: 'particle_whipped_cream+4',
  _Topping_2_2: 'Topping+2+2',
  _CrumbTopping_2_2: 'CrumbTopping+2+2',
  _Monster_MouthOooh: 'Monster_MouthOooh',
  _SplashPart_4: 'SplashPart+4',
  _CrumbCream_1: 'CrumbCream+1',
  _CrumbCream_4: 'CrumbCream+4',
  _CrumbSauce_1: 'CrumbSauce+1',
  _CrumbSauce_2: 'CrumbSauce+2',
  _CrumbSauce_3: 'CrumbSauce+3',
  _CrumbSauce_4: 'CrumbSauce+4',
  _CrumbCream_2: 'CrumbCream+2',
  _CrumbCream_3: 'CrumbCream+3',
  _Monster_Eye: 'Monster_Eye',
  _Topping_1_1: 'Topping+1+1',
  _Topping_1_3: 'Topping+1+3',
  _Topping_1_4: 'Topping+1+4',
  _Topping_2_4: 'Topping+2+4',
  _CrumbTopping_2_4: 'CrumbTopping+2+4',
  _CrumbTopping_1_1: 'CrumbTopping+1+1',
  _CrumbTopping_1_2: 'CrumbTopping+1+2',
  _CrumbTopping_1_3: 'CrumbTopping+1+3',
  _CrumbTopping_1_4: 'CrumbTopping+1+4',
  _ConeCrumb: 'ConeCrumb',
  _Monster_Eye_Closed: 'Monster_Eye_Closed',
  _PinkStripes: 'PinkStripes',
  _BG_ITEM_77: 'BG+ITEM+77',
  _Flavor_3: 'Flavor+3',
  _Flavor_4: 'Flavor+4',
  _Flavor_5: 'Flavor+5',
  _IntroTreat_4: 'IntroTreat+4',
  _Monster_Body: 'Monster_Body',
  _BUTTON_StartOver_2: 'BUTTON_StartOver+2',
  _IntroTreat_3: 'IntroTreat+3',
  _Sauce_1_Top: 'Sauce+1+Top',
  _Sauce_Bottle_Squeeze: 'Sauce+Bottle+Squeeze',
  _Whipping_1: 'Whipping+1',
  _Sauce_Bottle_Fill: 'Sauce+Bottle+Fill',
  _Sauce_Bottle: 'Sauce+Bottle',
  _Whipping_2: 'Whipping+2',
  _Whipping_3: 'Whipping+3',
  _Sauce_2_Top: 'Sauce+2+Top',
  _Monster_ArmDown: 'Monster_ArmDown',
  _Sauce_Bottle_Squeeze_Fill: 'Sauce+Bottle+Squeeze+Fill',
  _Whipping_4: 'Whipping+4',
  _PicFrame_1: 'PicFrame+1',
  _Sauce_3_Top: 'Sauce+3+Top',
  _BG_ITEM_5: 'BG+ITEM+5',
  _Sauce_4_Top: 'Sauce+4+Top',
  _ICON_MenuToppings_2: 'ICON_MenuToppings+2',
  _ICON_MenuContainer_2HIGHLIGHT: 'ICON_MenuContainer+2HIGHLIGHT',
  _PicFrame_2: 'PicFrame+2',
  _ICON_MenuToppings_5: 'ICON_MenuToppings+5',
  _PicFrame_3: 'PicFrame+3',
  _PicFrame_4: 'PicFrame+4',
  _BG_ITEM_3: 'BG+ITEM+3',
  _BG_ITEM_4: 'BG+ITEM+4',
  _bear_left_leg_bitmap: 'bear/left_leg_bitmap',
  _BtnPrint: 'BtnPrint',
  _ICON_MenuSauce_1: 'ICON_MenuSauce+1',
  _ICON_MenuContainer_4HIGHLIGHT: 'ICON_MenuContainer+4HIGHLIGHT',
  _BtnSave: 'BtnSave',
  _BtnSaveClose: 'BtnSaveClose',
  _FlavorSplash_2: 'FlavorSplash+2',
  _FlavorSplash_3: 'FlavorSplash+3',
  _ICON_MenuContainer_2: 'ICON_MenuContainer+2',
  _ICON_MenuContainer_3: 'ICON_MenuContainer+3',
  _ICON_MenuWhipped_Cream_1HIGHLIGHT: 'ICON_MenuWhipped_Cream+1HIGHLIGHT',
  _ICON_MenuFlavor_2HIGHLIGHT: 'ICON_MenuFlavor+2HIGHLIGHT',
  _ICON_MenuFlavor_3HIGHLIGHT: 'ICON_MenuFlavor+3HIGHLIGHT',
  _ICON_MenuFlavor_4HIGHLIGHT: 'ICON_MenuFlavor+4HIGHLIGHT',
  _ICON_MenuWhipped_Cream_3HIGHLIGHT: 'ICON_MenuWhipped_Cream+3HIGHLIGHT',
  _ICON_MenuWhipped_Cream_4HIGHLIGHT: 'ICON_MenuWhipped_Cream+4HIGHLIGHT',
  _ICON_MenuFlavor_5HIGHLIGHT: 'ICON_MenuFlavor+5HIGHLIGHT',
  _ICON_MenuContainer_1HIGHLIGHT: 'ICON_MenuContainer+1HIGHLIGHT',
  _ICON_MenuToppings_1: 'ICON_MenuToppings+1',
  _Topping_4_1: 'Topping+4+1',
  _BUTTON_Save: 'BUTTON_Save',
  _BUTTON_StartOver: 'BUTTON_StartOver',
  _ICON_MenuContainer_1: 'ICON_MenuContainer+1',
  _ICON_MenuSauce_1HIGHLIGHT: 'ICON_MenuSauce+1HIGHLIGHT',
  _ICON_MenuWhipped_Cream_1: 'ICON_MenuWhipped_Cream+1',
  _ICON_MenuFlavor_4: 'ICON_MenuFlavor+4',
  _ICON_MenuFlavor_5: 'ICON_MenuFlavor+5',
  _ICON_MenuWhipped_Cream_2: 'ICON_MenuWhipped_Cream+2',
  _ICON_MenuWhipped_Cream_3: 'ICON_MenuWhipped_Cream+3',
  _Menu_1: 'Menu+1',
  _Menu_2: 'Menu+2',
  _ICON_MenuWhipped_Cream_4: 'ICON_MenuWhipped_Cream+4',
  _ICON_MenuContainer_3HIGHLIGHT: 'ICON_MenuContainer+3HIGHLIGHT',
  _ICON_MenuFlavor_1: 'ICON_MenuFlavor+1',
  _ICON_MenuFlavor_2: 'ICON_MenuFlavor+2',
  _ICON_MenuSauce_2: 'ICON_MenuSauce+2',
  _ICON_MenuFlavor_3: 'ICON_MenuFlavor+3',
  _ICON_MenuToppings_4HIGHLIGHT: 'ICON_MenuToppings+4HIGHLIGHT',
  _ICON_MenuSauce_2HIGHLIGHT: 'ICON_MenuSauce+2HIGHLIGHT',
  _ICON_MenuSauce_3HIGHLIGHT: 'ICON_MenuSauce+3HIGHLIGHT',
  _ICON_MenuSauce_4HIGHLIGHT: 'ICON_MenuSauce+4HIGHLIGHT',
  _BUTTON_Ready: 'BUTTON_Ready',
  _ICON_MenuSauce_3: 'ICON_MenuSauce+3',
  _bear_closed_eyes_bitmap: 'bear/closed_eyes_bitmap',
  _BiteMask: 'BiteMask',
  _ICON_MenuToppings_4: 'ICON_MenuToppings+4',
  _ICON_MenuSauce_4: 'ICON_MenuSauce+4',
  _FlavorSplash_4: 'FlavorSplash+4',
  _FlavorSplash_1: 'FlavorSplash+1',
  _Menu_3: 'Menu+3',
  _bear_hat_bitmap: 'bear/hat_bitmap',
  _Menu_4: 'Menu+4',
  _Menu_5: 'Menu+5',
  _bear_eyes_bitmap: 'bear/eyes_bitmap',
  _Front_Counter: 'Front_Counter',
  _Mouse_Pointer: 'Mouse_Pointer',
  _Topping_2_3: 'Topping+2+3',
  _particle_whipped_cream_1: 'particle_whipped_cream+1',
  _particle_whipped_cream_2: 'particle_whipped_cream+2',
  _CrumbTopping_2_3: 'CrumbTopping+2+3',
  _SplashPart_3: 'SplashPart+3',
  _SplashPart_5: 'SplashPart+5',
  _SplashPart_1c: 'SplashPart+1c',
  _SplashPart_2: 'SplashPart+2',
  _Topping_2_1: 'Topping+2+1',
  _SplashPart_1: 'SplashPart+1',
  _CrumbTopping_5_1: 'CrumbTopping+5+1',
  _CrumbTopping_1_5: 'CrumbTopping+1+5',
  _Topping_1_2: 'Topping+1+2',
  _Topping_1_5: 'Topping+1+5',
  _CrumbTopping_3_1: 'CrumbTopping+3+1',
  _CrumbTopping_2_5: 'CrumbTopping+2+5',
  _Topping_2_5: 'Topping+2+5',
}